import React, { useState } from 'react'
import { login, logout } from '@/features/auth'

interface AuthContextType {
  isAuthenticated: boolean
  userLogin: (account: string, password: string) => Promise<any>
  userLogout: () => void
}

export const AuthContext = React.createContext<AuthContextType>(null!)

/**
 * 授权
 * @param param0
 * @returns
 */
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!window.localStorage.getItem('kk-token'))

  /**
   * 用户登录
   * @param account 登录账号
   * @param password
   * @param key
   * @param code
   * @param callback
   * @returns
   */
  const userLogin = (account: string, password: string) => {
    return new Promise((resolve, reject) => {
      login(account, password)
        .then((token: any) => {
          if (token) {
            setIsAuthenticated(true)
            window.localStorage.setItem('kk-token', token)
            resolve(true)
          } else {
            reject(false)
          }
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  }

  /**
   * 用户登出
   * @returns
   */
  const userLogout = () => {
    return new Promise((resolve, reject) => {
      logout()
        .then((res: any) => {
          setIsAuthenticated(false)
          window.localStorage.removeItem('kk-token')
          resolve(true)
        })
        .catch((e: any) => {
          reject(false)
        })
    })
  }

  return <AuthContext.Provider value={{ isAuthenticated, userLogin, userLogout }}>{children}</AuthContext.Provider>
}
